import CaretUpIcon from '@offerzen/zenicon/CaretUpIcon'
import CaretDownIcon from '@offerzen/zenicon/CaretDownIcon'
import CaretUpDownIcon from '@offerzen/zenicon/CaretUpDownIcon'

export const directionMap = {
  asc: {
    id: 'asc',
    icon: CaretUpIcon,
  },
  desc: {
    id: 'desc',
    icon: CaretDownIcon,
  },
  'asc-desc': {
    id: 'asc-desc',
    icon: CaretUpDownIcon,
  },
}

export const getCurrentDirection = (column, currentColumn, currentDir) => {
  // If current column, return current direction
  if (currentColumn === column) return currentDir
  // Otherwise, no direction specified
  return 'asc-desc'
}

export const getNextDirection = (column, currentColumn, currentDir) => {
  // If not the current column, sort ascending
  if (currentColumn !== column) return 'asc'

  // Otherwise, reverse direction
  if (currentDir === 'asc') return 'desc'
  return 'asc'
}

export const reverseDirection = (reversableColumns = [], column = undefined, dir = undefined) => {
  // Do nothing if no sorting is applied
  if (!column || !dir) return undefined

  // Reverse direction if the sorting is by a column found in the list of reversable columns
  if (reversableColumns.includes(column)) {
    return dir === 'asc' ? 'desc' : 'asc'
  }

  // Otherwise, return the same direction
  return dir
}
